var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherRainHeavy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1346 67.6324H46.9686L53.8386 54.2843C54.1348 53.7015 54.3737 53.0422 54.517 52.3733C55.396 48.2266 52.7589 44.1562 48.6121 43.2676C44.4653 42.3886 40.3949 45.0257 39.5159 49.1725L34.92 70.7473L34.7767 71.4066C34.7099 71.7123 34.6812 72.0276 34.6812 72.3525C34.6812 74.9227 36.7641 77.0057 39.3343 77.0057H44.4175L41.6753 88.4428C41.5797 88.8537 41.7231 89.3028 42.0861 89.5703C42.5734 89.9238 43.2423 89.8092 43.5958 89.3314L54.517 74.273C55.0138 73.5851 55.3196 72.7347 55.3196 71.8174C55.3196 69.5052 53.4469 67.6324 51.1346 67.6324Z",
    fill: "url(#paint0_linear_43_2896)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7407 24.254C69.8234 10.8295 58.6538 0.223633 45 0.223633C31.3461 0.223633 20.1765 10.8295 19.2593 24.254C9.09292 24.7604 1 33.1591 1 43.4592C1 53.7593 9.6089 62.6835 20.2243 62.6835H69.7756C80.391 62.6835 89 54.0746 89 43.4592C89 32.8438 80.907 24.7604 70.7311 24.254H70.7407Z",
    fill: "url(#paint1_radial_43_2896)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6,
    d: "M46.8154 26.6426C39.5728 20.7664 36.7542 11.8326 40.4997 6.67301C44.2547 1.5134 53.1693 2.09624 60.4119 7.96291C67.6449 13.8296 70.4732 22.7825 66.7181 27.9325C62.9631 33.0921 54.0484 32.5188 46.8154 26.6426Z",
    fill: "url(#paint2_radial_43_2896)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M70.8845 43.9939C65.1993 39.3789 62.9731 32.3561 65.9255 28.2953C68.8779 24.2441 75.8816 24.6932 81.5667 29.3081C87.2519 33.9231 89.4781 40.9555 86.5257 45.0067C83.5733 49.0675 76.5696 48.6089 70.8845 43.9939Z",
    fill: "url(#paint3_radial_43_2896)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2,
    d: "M14.7494 44.6439C10.5549 38.0893 5.67231 34.9458 3.84734 37.602C2.03192 40.2583 3.95244 47.7206 8.14701 54.2656C12.3511 60.8107 17.2241 63.9638 19.0491 61.3075C20.8741 58.6513 18.944 51.189 14.7494 44.6439Z",
    fill: "url(#paint4_radial_43_2896)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8997 75.1909C21.82 77.0637 19.4122 77.7134 17.5299 76.6241C15.6476 75.5444 15.0075 73.1366 16.0872 71.2543C17.1764 69.372 23.8839 65.6074 23.8839 65.6074C23.8839 65.6074 23.9795 73.2991 22.8902 75.1814L22.8997 75.1909Z",
    fill: "url(#paint5_radial_43_2896)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M16.2112 74.5411C15.5997 72.955 15.9724 71.2733 17.0425 70.8051C18.1127 70.3274 19.4694 71.2351 20.0714 72.8307C20.6829 74.4264 20.3103 76.0985 19.2401 76.5667C18.17 77.0444 16.8131 76.1367 16.2112 74.5411Z",
    fill: "url(#paint6_radial_43_2896)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2348 86.6948C28.1455 88.5676 25.7473 89.2173 23.865 88.1281C21.9827 87.0484 21.3425 84.6405 22.4317 82.7582C23.521 80.8759 30.2285 77.1113 30.2285 77.1113C30.2285 77.1113 30.324 84.803 29.2348 86.6853V86.6948Z",
    fill: "url(#paint7_radial_43_2896)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M22.5467 86.045C21.9351 84.4589 22.3078 82.7772 23.3779 82.309C24.4481 81.8313 25.8049 82.739 26.4068 84.3347C27.0184 85.9303 26.6457 87.6024 25.5851 88.0706C24.5149 88.5483 23.1582 87.6406 22.5562 86.045H22.5467Z",
    fill: "url(#paint8_radial_43_2896)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5595 75.1909C72.4798 77.0637 70.072 77.7134 68.1897 76.6241C66.3074 75.5444 65.6672 73.1366 66.7565 71.2543C67.8361 69.372 74.5532 65.6074 74.5532 65.6074C74.5532 65.6074 74.6487 73.2991 73.5595 75.1814V75.1909Z",
    fill: "url(#paint9_radial_43_2896)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M66.8709 74.5411C66.2594 72.955 66.632 71.2733 67.7021 70.8051C68.7723 70.3274 70.129 71.2351 70.731 72.8307C71.3425 74.4264 70.9699 76.0985 69.8997 76.5667C68.8296 77.0444 67.4728 76.1367 66.8709 74.5411Z",
    fill: "url(#paint10_radial_43_2896)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6576 86.6948C61.5779 88.5676 59.1701 89.2173 57.2878 88.1281C55.4055 87.0484 54.7653 84.6405 55.8546 82.7582C56.9438 80.8759 63.6513 77.1113 63.6513 77.1113C63.6513 77.1113 63.7469 84.803 62.6576 86.6853V86.6948Z",
    fill: "url(#paint11_radial_43_2896)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M55.969 86.045C55.3575 84.4589 55.7301 82.7772 56.8003 82.309C57.8704 81.8313 59.2272 82.739 59.8291 84.3347C60.4407 85.9303 60.068 87.6024 58.9979 88.0706C57.9277 88.5483 56.571 87.6406 55.969 86.045Z",
    fill: "url(#paint12_radial_43_2896)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_2896",
    x1: 38.4362,
    y1: 89.0448,
    x2: 49.4434,
    y2: 54.3703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFE036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_43_2896",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.1027 13.4402) rotate(-180) scale(67.1323 49.0065)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6CCD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#97B6BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D87B4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_43_2896",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.631 -198.642) rotate(126.03) scale(11.5866 16.8532)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_43_2896",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(231.137 -180.549) rotate(126.03) scale(9.09983 13.2361)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_43_2896",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.3838 49.2989) rotate(-25.71) scale(4.65321 13.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_43_2896",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6526 74.2888) rotate(30) scale(9.44971 9.44972)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D5F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85BCF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_43_2896",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(249.449 -31.8754) rotate(156.04) scale(2.11784 3.08048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_43_2896",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9906 85.8034) rotate(29.9999) scale(9.44975 9.44974)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D5F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85BCF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_43_2896",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256.416 -20.6395) rotate(156.04) scale(2.11784 3.08048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_43_2896",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.3151 74.2904) rotate(30.0001) scale(9.4497 9.44972)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D5F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85BCF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_43_2896",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(301.201 -32.3655) rotate(156.04) scale(2.11782 3.08047)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_43_2896",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4105 85.8017) rotate(30.0001) scale(9.44971 9.44973)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D5F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85BCF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_43_2896",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(290.548 -20.9765) rotate(156.04) scale(2.11782 3.08047)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherRainHeavy);
export default __webpack_public_path__ + "static/media/weather-rain-heavy.ecc79f901b2c6deb8113548534d68ec2.svg";
export { ForwardRef as ReactComponent };